// extracted by mini-css-extract-plugin
export default {"feedback":"feedback_feedback__RtLD1","field":"feedback_field__WtDX6","btn_field":"feedback_btn_field__iB7Xv"};